import { render, staticRenderFns } from "./overProof.vue?vue&type=template&id=042b8723&"
import script from "./overProof.vue?vue&type=script&lang=js&"
export * from "./overProof.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports